import { DEFAULT_CURRENCY, moneyFormat } from "@redotech/money/util";
import {
  Condition,
  PriceOption,
} from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export interface TotalReturnValueState {
  amount: string;
  priceOption: PriceOption | null;
}

export const TOTAL_RETURN_VALUE = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<TotalReturnValueState>
  >,
): ConditionType<TotalReturnValueState, Condition.TotalReturnValue> => ({
  name: "Total Return Value",
  description(state) {
    if (!state.priceOption) {
      return "The total return value of every item the customer is returning, this includes any discounts";
    }
    return `The total return value of every item the customer is returning, this includes any discounts, is ${state.priceOption.toLowerCase()} ${moneyFormat(
      { amount: +state.amount, currency: DEFAULT_CURRENCY },
    )}`;
  },
  Details(props: ConditionTypeDetailsProps<TotalReturnValueState>) {
    return React.createElement(Details, props);
  },
  empty: { amount: (0).toFixed(2), priceOption: null },
  fromModel(model) {
    return { amount: model.amount.toFixed(2), priceOption: model.priceOption };
  },
  toModel(state) {
    return {
      type: Condition.TOTAL_RETURN_VALUE,
      amount: +state.amount,
      priceOption: state.priceOption,
    };
  },
  valid(state) {
    return +state.amount >= 0 && state.priceOption !== null;
  },
});
